import React from 'react';

import { cn } from '@/lib/utils';
import CreateInvoiceStepItem from '@/components/molecules/invoice/CreateInvoiceStepItem';

interface Step {
  number: number;
  title: string;
}

export interface CreateWorkActivityStepsProps {
  activeStep: number;
  className?: string;
}

const steps: Step[] = [
  { number: 1, title: 'Activity' },
  { number: 2, title: 'Allocation' },
  { number: 3, title: 'Document' }
];

const CreateWorkActivitySteps: React.FC<CreateWorkActivityStepsProps> = ({ activeStep, className }) => {
  return (
    <div className={cn('card flex flex-col gap-10 py-5 px-6 relative', className)}>
      {steps.map((step) => (
        <CreateInvoiceStepItem
          key={step.number}
          stepNumber={step.number}
          title={step.title}
          isActive={activeStep === step.number}
          isCompleted={activeStep > step.number}
        />
      ))}

      <div className="z-[0] absolute h-[calc(100%-45px)] w-[1.5px] bg-secondary top-[22px] bottom-5 left-9" />
    </div>
  );
};

export default CreateWorkActivitySteps;
